/* eslint-disable spaced-comment */

import { usePagination, DOTS } from './hooks/usePagination';

import './styles/CustomPagination.scss';

export const CustomPagination = (props) => {
  const {
    pageSize,
    totalCount,
    currentPage,
    onPageChange,
    className = '',
    siblingCount = 1,
  } = props;

  const paginationRange = usePagination({
    pageSize,
    totalCount,
    currentPage,
    siblingCount,
  });

  if (currentPage === 0 || paginationRange.length < 2) return null;

  const onNext = () => onPageChange(currentPage + 1);

  const onPrevious = () => onPageChange(currentPage - 1);

  const lastPage = paginationRange[paginationRange.length - 1];

  return (
    <ul className={`pagination-container-admin ${className}`}>
      <li
        onClick={onPrevious}
        className={`pagination-item ${currentPage === 1 ? 'disabled' : ''}`}
      >
        <span className="arrow left" />
      </li>

      {paginationRange.map((pageNumber, i) => {
        if (pageNumber === DOTS)
          return (
            <li
              key={`pagination-item-dots-${i}`}
              className="pagination-item dots"
            >
              &#8230;
            </li>
          );

        return (
          <li
            key={`pagination-item-${pageNumber}`}
            onClick={() =>
              currentPage !== pageNumber ? onPageChange(pageNumber) : null
            }
            className={`pagination-item ${
              pageNumber === currentPage ? 'selected' : ''
            }`}
          >
            <span className="number">{pageNumber}</span>
          </li>
        );
      })}

      <li
        onClick={onNext}
        className={`pagination-item ${
          currentPage === lastPage ? 'disabled' : ''
        }`}
      >
        <span className="arrow right" />
      </li>
    </ul>
  );
};
